import get from 'lodash/get'
import set from 'lodash/set'

export function buildAddress(params: any, index = 1) {
  const addressNameIndex = `contact.address${index}`

  //the params can be contact.address1, or it can be the address object,
  //if it is the address object itself need to update it to contact.address1
  if (!get(params, addressNameIndex)) {
    params = set({}, addressNameIndex, params)
  }

  const street1 = get(params, `${addressNameIndex}.street1`, '')
  const street2 = get(params, `${addressNameIndex}.street2`, '')
  const street3 = get(params, `${addressNameIndex}.street3`, '')
  const city = get(params, `${addressNameIndex}.city`, '')
  const state = get(params, `${addressNameIndex}.state.value`) || get(params, `${addressNameIndex}.state`) || ''
  const zip = get(params, `${addressNameIndex}.zip`, '')
  const country = get(params, `${addressNameIndex}.country`, '')
  const company = get(params, `${addressNameIndex}.company`, '')
  const phone = get(params, `${addressNameIndex}.phone`, '')
  const name = get(params, `${addressNameIndex}.name`, '')

  let fullAddress: string | null = null
  let fullAddress2: string | null = null

  if (company) {
    fullAddress2 = `${company}`
  }
  if (name) {
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${name}` : `${name}`
  }
  if (phone) {
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${phone}` : `${phone}`
  }

  if (street1) {
    fullAddress = fullAddress ? `${fullAddress}, ${street1}` : `${street1}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${street1}` : `${street1}`
  }
  if (street2) {
    fullAddress = fullAddress ? `${fullAddress}, ${street2}` : `${street2}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${street2}` : `${street2}`
  }
  if (street3) {
    fullAddress = fullAddress ? `${fullAddress}, ${street3}` : `${street3}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${street3}` : `${street3}`
  }

  if (city) {
    fullAddress = fullAddress ? `${fullAddress}, ${city}` : `${city}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${city}` : `${city}`
  }
  if (state) {
    fullAddress = fullAddress ? `${fullAddress}, ${state}` : `${state}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${state}` : `${state}`
  }
  if (country) {
    fullAddress = fullAddress ? `${fullAddress}, ${country}` : `${country}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${country}` : `${country}`
  }
  if (zip) {
    fullAddress = fullAddress ? `${fullAddress}, ${zip}` : `${zip}`
    fullAddress2 = fullAddress2 ? `${fullAddress2}, ${zip}` : `${zip}`
  }

  return {
    company,
    name,
    phone,
    street1,
    street2,
    street3,
    city,
    state,
    country,
    zip,
    gps: {
      lng: get(params, `${addressNameIndex}.gps.lng`),
      lat: get(params, `${addressNameIndex}.gps.lat`),
    },
    fullAddress,
    fullAddress2,
  }
}
